module.exports = __webpack_public_path__ + "img/08.00c7e578.png";